{
  "de": {
    "activity": {
      "attributes": {
        "end": "Ende",
        "now": "Jetzt",
        "title": "Aktivitäten"
      },
      "labels": {
        "no_activities": "Noch keine Aktivitäten",
        "no_activities_subtitle": "Wenn jemand eine neue Ankündigung, Entscheidung, Frage usw. erstellt, sehen Sie sie hier.",
        "not_opened_yet": "Noch nicht gesehen"
      },
      "projects": {
        "announcement": {
          "create": "hat eine Neuigkeit erstellt."
        },
        "building": {
          "create": "hat das Gebäude <i>'{notifiable_name}'</i> erstellt."
        },
        "document": {
          "create": "hat das Dokument <i>'{notifiable_name}'</i> hochgeladen."
        },
        "lot": {
          "create": "hat das Grundstück <i>'{notifiable_name}'</i> erstellt."
        },
        "phase": {
          "create": "hat die Phase <i>'{notifiable_name}'</i> erstellt."
        },
        "published": {
          "customer": "hat die Entscheidung <i>'{notifiable_name}'</i> für den Kunden veröffentlicht.",
          "partners": "hat die Entscheidung <i>'{notifiable_name}'</i> für die Partner veröffentlicht."
        },
        "question": {
          "create": "hat die Frage <i>'{notifiable_name}'</i> in der FAQ <i>'{group_name}'</i> erstellt."
        },
        "space": {
          "create": "hat die Nebenfläche <i>'{notifiable_name}'</i> erstellt.",
          "update": "hat die Nebenfläche <i>'{notifiable_name}'</i> einer Einheit zugewiesen."
        },
        "survey_type": {
          "create": "hat eine Umfrage vom Typ <i>'{notifiable_name}'</i> erstellt."
        },
        "ticket": {
          "create": "hat die Konversation <i>'{notifiable_name}'</i> gestartet."
        },
        "unit": {
          "assign": "hat <i>'{notifiable_name}'</i> einem Kunden zugewiesen.",
          "create": "hat die Einheit <i>'{notifiable_name}'</i> erstellt.",
          "invisibled": "hat den Kundenzugang für <i>'{notifiable_name}'</i> entzogen.",
          "unassign": "hat <i>'{notifiable_name}'</i> vom Kunden entfernt.",
          "visibled": "hat den Kundenzugang für <i>'{notifiable_name}'</i> gewährt."
        }
      },
      "units": {
        "announcement": {
          "create": "hat eine Neuigkeit erstellt."
        },
        "decision": {
          "create": "hat die Entscheidung <i>'{notifiable_name}'</i> erstellt.",
          "not_interested": "ist an der Entscheidung <i>'{notifiable_name}'</i> nicht interessiert.",
          "published": {
            "customer": "hat die Entscheidung <i>'{notifiable_name}'</i> für den Kunden veröffentlicht.",
            "partners": "hat die Entscheidung <i>'{notifiable_name}'</i> für die Partner veröffentlicht."
          },
          "relaunched": "hat die Entscheidung <i>'{notifiable_name}'</i> erneut verfügbar gemacht."
        },
        "decision_document": {
          "create": "hat das Dokument <i>'{notifiable_name}'</i> in der Entscheidung <i>'{group_name}'</i> hochgeladen."
        },
        "decision_proposal": {
          "approved": "hat das Angebot <i>'{notifiable_name}'</i> in der Entscheidung <i>'{group_name}'</i> genehmigt.",
          "create": {
            "customer": "hat das Angebot <i>'{notifiable_name}'</i> mit dem Kunden geteilt.",
            "employee": "hat das Angebot <i>'{notifiable_name}'</i> erstellt.",
            "partnergroup": "hat das Angebot <i>'{notifiable_name}'</i> mit Partner <i>{target_name}</i> geteilt."
          },
          "unapproved": "hat die Genehmigung für das Angebot <i>'{notifiable_name}'</i> in der Entscheidung <i>'{group_name}'</i> aufgehoben.",
          "updated": "hat das Angebot <i>'{notifiable_name}'</i> in der Entscheidung <i>'{group_name}'</i> aktualisiert."
        },
        "document": {
          "create": "hat das Dokument <i>'{notifiable_name}'</i> hochgeladen.",
          "destroy": "hat das Dokument <i>'{notifiable_name}'</i> gelöscht"
        },
        "issue": {
          "approval": {
            "create": "hat die Genehmigung des Kunden angefordert.",
            "delete": "hat die Genehmigungsanfrage des Kunden gelöscht.",
            "rejected": "hat diesen Punkt abgelehnt."
          },
          "approved": "hat diesen Punkt genehmigt",
          "create": "hat diesen Punkt erstellt",
          "status": {
            "update": "hat den Status des Punkts <i>'{notifiable_name}'</i> auf <i>{target_name}</i> geändert."
          }
        },
        "proposal": {
          "deleted": "hat das Angebot <i>'{notifiable_name}'</i> entfernt."
        },
        "question": {
          "create": "hat die Frage <i>'{notifiable_name}'</i> in der FAQ <i>'{group_name}'</i> erstellt."
        },
        "space": {
          "update": "hat die Nebenfläche <i>'{notifiable_name}'</i> dieser Einheit zugewiesen."
        },
        "survey": {
          "create": "hat die Umfrage <i>'{notifiable_name}'</i> erstellt.",
          "published": "hat die Umfrage <i>'{notifiable_name}'</i> veröffentlicht."
        },
        "ticket": {
          "create": "hat die Konversation <i>'{notifiable_name}'</i> gestartet.",
          "message": {
            "move": "hat eine Nachricht in die Konversation <i>'{notifiable_name}'</i> verschoben."
          }
        },
        "unit": {
          "assign": "hat <i>'{notifiable_name}'</i> einem Kunden zugewiesen.",
          "invisibled": "hat den Kundenzugang für <i>'{notifiable_name}'</i> entzogen.",
          "unassign": "hat <i>'{notifiable_name}'</i> vom Kunden entfernt.",
          "visibled": "hat den Kundenzugang für <i>'{notifiable_name}'</i> gewährt."
        }
      }
    }
  }
}
